import { element, isString } from 'angular';
import 'angular-route';
export var CgMetadataDirective = [
    '$rootScope',
    'metadataConfiguration',
    function ($rootScope, metadataConfiguration) {
        var joinWithAnd = function (names) {
            if (names.length === 1) {
                return names[0];
            }
            else {
                return names.slice(0, -1).join(', ') + ' ' + metadataConfiguration.and + ' ' + names.slice(-1);
            }
        };
        var checkPageType = function (pageData) {
            if (pageData.searchResult) {
                return 'search';
            }
            if (pageData.solutionResult) {
                return 'solution';
            }
            if (pageData.compareResult) {
                return 'compare';
            }
        };
        var generateMetadata = function (pageData) {
            var configuration;
            var thirdPartyProducts = [];
            var gnProducts = [];
            var pageType = checkPageType(pageData);
            switch (pageType) {
                case 'search':
                    thirdPartyProducts = pageData.searchResult.thirdPartyProducts;
                    configuration = metadataConfiguration.gallery;
                    break;
                case 'solution':
                    thirdPartyProducts = pageData.solutionResult.thirdPartyProducts;
                    gnProducts = [pageData.solutionResult.group];
                    configuration = metadataConfiguration.solutions;
                    configuration.image = "https:" + pageData.solutionResult.group.images[0];
                    configuration.imageAlt = pageData.solutionResult.group.productName;
                    break;
                case 'compare':
                    thirdPartyProducts = pageData.compareResult.thirdPartyProducts;
                    gnProducts = pageData.compareResult.products;
                    configuration = metadataConfiguration.compare;
                    break;
                default:
                    configuration = metadataConfiguration.home;
                    break;
            }
            var joinedThirdPartyProducts = joinWithAnd(thirdPartyProducts.map(function (t) { return t.manufacturer + ' ' + t.name; }));
            var joinedGnProducts = joinWithAnd(gnProducts.map(function (p) { return p.productName; }));
            return {
                description: configuration.descriptionToken
                    .replace('{3P Products}', joinedThirdPartyProducts)
                    .replace('{GN Products}', joinedGnProducts),
                image: configuration.image,
                imageAlt: configuration.imageAlt,
                title: configuration.titleToken
                    .replace('{3P Products}', joinedThirdPartyProducts)
                    .replace('{GN Products}', joinedGnProducts),
            };
        };
        return {
            link: function ($scope, $element, $attributes) {
                $rootScope.$on('$routeChangeSuccess', function (event, current, previous) {
                    if (!current || !current.locals) {
                        return;
                    }
                    if (previous === undefined) {
                        return;
                    }
                    var metadata = generateMetadata(current.locals);
                    document.title = metadata.title;
                    element('meta[property=og\\:title]').attr('content', metadata.title);
                    element('meta[name=description]').attr('content', metadata.description);
                    element('meta[property=og\\:description]').attr('content', metadata.description);
                    if (isString(metadata.image) && metadata.image !== '') {
                        element('meta[property=og\\:image]').attr('content', metadata.image);
                        element('meta[property=og\\:image\\:alt]').attr('content', metadata.imageAlt);
                    }
                });
            },
            restrict: 'E',
        };
    },
];
